import PropTypes from 'prop-types';
import { CustomAttachmentField } from '../../incidentForm/fields/customAttachment/customAttachmentField';

const AttachmentsComponent = ({ field, value, onChange, disabledField }) => {
  return (
    <CustomAttachmentField field={field} value={value} onChange={onChange} readOnly={disabledField} />
  );
};

export default AttachmentsComponent;

AttachmentsComponent.propTypes = {
  field: PropTypes.object,
  value: PropTypes.array,
  onChange: PropTypes.func,
  disabledField: PropTypes.bool,
};
